var React = require('react');

function CertificateLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31 47.58a2 2 0 01-1.41-.58L24 41.41 18.42 47A2 2 0 0115 45.58V36a1 1 0 012 0v9.58l6.29-6.29a1.002 1.002 0 011.42 0L31 45.58V36a1 1 0 012 0v9.58a2 2 0 01-2 2z","key":0}),React.createElement("path",{"d":"M24 35a17 17 0 110-34 17 17 0 010 34zm0-32a15 15 0 100 30 15 15 0 000-30z","key":1}),React.createElement("path",{"d":"M24 30a12 12 0 110-24 12 12 0 010 24zm0-22a10 10 0 100 20 10 10 0 000-20z","key":2})]);
}

CertificateLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CertificateLight;

CertificateLight.default = CertificateLight;
